export default "/steper-arrow.e866a5e0b34e6b2a213348dfc73a3aba.svg";